module.exports = __webpack_public_path__ + "img/clap.3d8e222c.gif";